/**
 * Check if value is an object
 * @param {*} value Value to check
 * @returns {boolean}
 */
export default (value) => {
	return typeof value === 'object' && value !== null && !Array.isArray(value);
};
